"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageGroups = exports["default"] = exports.PAGE_WIDTH = exports.PAGE_PADDING = exports.PAGE_HEIGHT = exports.EXTRA_HEIGHT = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _reactSizeme = _interopRequireDefault(require("react-sizeme"));
var _md = _interopRequireDefault(require("md5"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _classnames2 = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PAGE_HEIGHT = exports.PAGE_HEIGHT = 1100;
var PAGE_WIDTH = exports.PAGE_WIDTH = 850;
var PAGE_PADDING = exports.PAGE_PADDING = 40;
var EXTRA_HEIGHT = exports.EXTRA_HEIGHT = 40;
var getPageGroups = exports.getPageGroups = function getPageGroups(_ref) {
  var _ref$prefixHeight = _ref.prefixHeight,
    prefixHeight = _ref$prefixHeight === void 0 ? 0 : _ref$prefixHeight,
    _ref$tableWrapperHeig = _ref.tableWrapperHeight,
    tableWrapperHeight = _ref$tableWrapperHeig === void 0 ? 0 : _ref$tableWrapperHeig,
    _ref$tableHeaderHeigh = _ref.tableHeaderHeight,
    tableHeaderHeight = _ref$tableHeaderHeigh === void 0 ? 0 : _ref$tableHeaderHeigh,
    _ref$rowsHeights = _ref.rowsHeights,
    rowsHeights = _ref$rowsHeights === void 0 ? [] : _ref$rowsHeights,
    _ref$rowsSpans = _ref.rowsSpans,
    rowsSpans = _ref$rowsSpans === void 0 ? [] : _ref$rowsSpans,
    _ref$extraHeight = _ref.extraHeight,
    extraHeight = _ref$extraHeight === void 0 ? 0 : _ref$extraHeight,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? PAGE_HEIGHT : _ref$height;
  var pages = [];
  var left = height - PAGE_PADDING * 2 - prefixHeight - tableWrapperHeight - tableHeaderHeight - extraHeight;
  var count = 0;
  var last = 0;
  var span = 1;
  var index = 0;
  while (index < rowsHeights.length) {
    var groupCount = 0;
    var groupHeight = 0;
    do {
      span = Math.max(span - 1, rowsSpans[index] || 1);
      left -= rowsHeights[index];
      groupCount++;
      groupHeight += rowsHeights[index];
      index++;
    } while (span > 1 && index < rowsHeights.length);
    if (count === 0 || left >= 0) {
      count += groupCount;
    } else {
      pages.push([last, last + count]);
      last += count;
      count = groupCount;
      left = height - PAGE_PADDING * 2 - tableWrapperHeight - tableHeaderHeight - groupHeight - extraHeight;
    }
  }
  if (count > 0) {
    pages.push([last, last + count]);
  }
  return pages;
};
var ReportWrapper = /*#__PURE__*/function (_React$Component) {
  function ReportWrapper(props) {
    var _this;
    _classCallCheck(this, ReportWrapper);
    _this = _callSuper(this, ReportWrapper, [props]);
    _defineProperty(_this, "getReportHeight", function () {
      var height = _this.report.clientHeight;
      if (height !== _this.state.reportHeight) {
        _this.setState({
          reportHeight: height
        });
      }
    });
    _defineProperty(_this, "getActualHeigh", function () {
      return _this.props.orientation === 'portrait' ? PAGE_HEIGHT : PAGE_WIDTH;
    });
    _defineProperty(_this, "download", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var pages, resultedPages, actualHeight, _addPage, _iterator4, _step4, page, styles, html, serviceUrl, base, handle, settings, result, link;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e && e.preventDefault();
              if (!_this.props.disableDownload) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _this.setState({
                loading: true
              });
              pages = _this.html.querySelectorAll(".".concat(_style["default"].page));
              resultedPages = [];
              actualHeight = _this.getActualHeigh(); // This function will try to divide tables into separate pages if table is bigger than the page height
              _addPage = function addPage(html) {
                if (!html) {
                  return;
                }
                var page = document.createElement('div');
                page.classList.add(_style["default"].tempWrapper);
                page.classList.add(_style["default"][_this.props.orientation]);
                page.innerHTML = html;
                document.body.appendChild(page);
                var addInitialPage = function addInitialPage() {
                  resultedPages.push("<div class=\"".concat(_style["default"].page, "\">").concat(page.innerHTML, "</div>"));
                  page.remove();
                };
                if (page.offsetHeight <= actualHeight) {
                  addInitialPage();
                  return;
                }
                var tables = page.querySelectorAll('table');
                if (tables.length === 0) {
                  addInitialPage();
                  return;
                }
                var table;
                var _iterator = _createForOfIteratorHelper(tables),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var node = _step.value;
                    // if it starts on the first page but ends on the another page
                    if (node.offsetTop - page.offsetTop < actualHeight - PAGE_PADDING && node.offsetTop + node.offsetHeight - page.offsetTop > actualHeight - PAGE_PADDING) {
                      table = node;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                if (!table) {
                  addInitialPage();
                  return;
                }
                var parent = table;
                while (parent.parentElement !== page) {
                  parent = parent.parentElement;
                }

                // Don't divide the table if there is something after the table inside wrapper
                var smallMargin = 2; // just to avoid rounded mistake
                if (parent.offsetTop + parent.offsetHeight > table.offsetTop + table.offsetHeight + smallMargin) {
                  addInitialPage();
                  return;
                }
                var prefix = '';
                var suffix = '';
                var suffixHeight = page.offsetTop + page.offsetHeight - (parent.offsetTop + parent.offsetHeight) - PAGE_PADDING;
                var blocks = [];
                var _iterator2 = _createForOfIteratorHelper(page.children),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var child = _step2.value;
                    if (child === parent) {
                      var tableHeader = table.querySelector(':scope > thead');
                      var rows = _toConsumableArray(table.querySelectorAll(':scope > tbody > tr'));
                      if (rows.length < 2) {
                        blocks.push(child.outerHTML);
                        continue;
                      }

                      // We have to add a row to the header just to fix column widths
                      // We'll get the row with the most columns (just to avoid row with colspan)
                      // and get the columns widths from there
                      var fixedWidths = rows.reduce(function (arr, row) {
                        var columns = row.querySelectorAll('td');
                        if (columns.length > arr.length) {
                          return _toConsumableArray(columns).reduce(function (result, column) {
                            result.push(column.offsetWidth);
                            return result;
                          }, []);
                        }
                        return arr;
                      }, []);
                      var widthFixedTr = "<tr class=\"".concat(_style["default"].widthFixer, "\">").concat(fixedWidths.map(function (width) {
                        return "<th style=\"width: ".concat(width, "px\"/>");
                      }).join(''), "</tr>");
                      var groups = getPageGroups({
                        prefixHeight: parent.offsetTop - page.offsetTop - PAGE_PADDING,
                        tableWrapperHeight: parent.offsetHeight - table.offsetHeight,
                        tableHeaderHeight: tableHeader ? tableHeader.offsetHeight : 0,
                        rowsHeights: rows.map(function (row) {
                          return row.offsetHeight;
                        }),
                        rowsSpans: rows.map(function (row) {
                          return Math.max.apply(Math, _toConsumableArray(_toConsumableArray(row.children).map(function (td) {
                            return td.rowSpan;
                          })));
                        }),
                        height: actualHeight,
                        extraHeight: EXTRA_HEIGHT // just in case the Chromium renders the content differently
                      });
                      var blockTemplate = child.cloneNode(true);
                      blockTemplate.querySelector('tbody').innerHTML = '';
                      var _iterator3 = _createForOfIteratorHelper(groups),
                        _step3;
                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var _step3$value = _slicedToArray(_step3.value, 2),
                            from = _step3$value[0],
                            to = _step3$value[1];
                          var currentBlock = blockTemplate.cloneNode(true);
                          currentBlock.style.tableLayout = 'fixed';
                          var currentTbody = currentBlock.querySelector('tbody');
                          if (from !== 0) {
                            // removing margin from table itself
                            currentTbody.parentElement.style.marginTop = 0;
                          }
                          if (to !== rows.length) {
                            // removing margin from table itself
                            currentTbody.parentElement.style.marginBottom = 0;
                          }
                          currentTbody.innerHTML = rows.slice(from, to).map(function (row) {
                            return row.outerHTML;
                          }).join('');
                          var blockHtml = currentBlock.outerHTML;
                          if (/<thead/.test(blockHtml)) {
                            blockHtml = blockHtml.replace(/(<thead[^>]*>)/, "$1".concat(widthFixedTr));
                          } else {
                            blockHtml = blockHtml.replace(/(<table[^>]*>)/, "$1<thead>".concat(widthFixedTr, "</thead>"));
                          }
                          blocks.push(blockHtml);
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                    } else if (blocks.length === 0) {
                      prefix += child.outerHTML;
                    } else {
                      suffix += child.outerHTML;
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                blocks.forEach(function (block, index) {
                  page.innerHTML = '';
                  if (index === 0) {
                    page.innerHTML += prefix;
                  }
                  page.innerHTML += block;
                  if (index === blocks.length - 1 && page.offsetHeight + suffixHeight <= actualHeight - EXTRA_HEIGHT) {
                    page.innerHTML += suffix;
                    suffix = '';
                  }
                  resultedPages.push("<div class=\"".concat(_style["default"].page, "\">").concat(page.innerHTML, "</div>"));
                });
                page.remove();
                _addPage(suffix);
              };
              _iterator4 = _createForOfIteratorHelper(pages);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  page = _step4.value;
                  _addPage(page.innerHTML);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              styles = [].slice.call(document.getElementsByTagName('head'));
              html = "\n            <html>\n                <head>\n                    ".concat(styles[0].innerHTML, "\n                    <style>\n                        .").concat(_style["default"].browserOnly, " {\n                            display: none;\n                        }\n                        .").concat(_style["default"].printOnly, " {\n                            display: initial;\n                        }\n                    </style>\n                </head>\n                <body style=\"margin: 0; padding: 0;\">\n                    <div class=\"").concat(_style["default"].print, "\">\n                        ").concat(resultedPages.join('').replace(/data-reactid="[^"]*"/g, ''), "\n                    </div>\n                </body>\n            </html>\n        ").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
              serviceUrl = 'https://pdf.service.3cisd.com'; // Generate handle for compose_file microservice
              base = _randomstring["default"].generate({
                length: 10,
                capitalization: 'lowercase'
              });
              handle = base + (0, _md["default"])(base + html.slice(-10000)).slice(0, 5);
              settings = _this.props.orientation === 'portrait' ? {
                width: '850px',
                height: '1100px'
              } : {
                height: '850px',
                width: '1100px'
              };
              _context.next = 18;
              return _cccisdAxios["default"].post("".concat(serviceUrl, "/v2"), {
                html: html,
                handle: handle,
                settings: settings
              });
            case 18:
              result = _context.sent;
              link = document.createElement('a');
              link.style.display = 'none';
              link.href = "".concat(serviceUrl, "/").concat(result.data.url, "?filename=").concat(_this.props.downloadFilename, ".pdf");
              link.download = "".concat(_this.props.downloadFilename, ".pdf");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              _this.setState({
                loading: false
              });
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getWidth", function () {
      var width = _this.props.size.width || 0;
      if (width > _this.reportWidth) {
        width = _this.reportWidth;
      }
      return width;
    });
    _defineProperty(_this, "getHeight", function () {
      if (_this.props.height !== 'auto') {
        return _this.props.height;
      }
      return "".concat(_this.state.reportHeight * _this.getScale(), "px");
    });
    _defineProperty(_this, "getScale", function () {
      return _this.getWidth() / _this.reportWidth;
    });
    _this.reportWidth = props.orientation === 'portrait' ? PAGE_WIDTH + 20 : PAGE_HEIGHT + 20;
    _this.state = {
      loading: false,
      reportHeight: props.orientation === 'portrait' ? PAGE_HEIGHT + 20 : PAGE_WIDTH + 20
    };
    return _this;
  }
  _inherits(ReportWrapper, _React$Component);
  return _createClass(ReportWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onRef(this);
      this.getReportHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.getReportHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showPagination = this.props.showPagination;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: showPagination ? {
          width: "".concat(this.props.width),
          height: "".concat(this.getHeight()),
          overflow: 'hidden'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_style["default"].reportWrapper, _defineProperty({}, _style["default"].styled, this.props.showPagination), _style["default"][this.props.orientation])
      }, this.props.showPagination && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].button
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary btn-sm",
        isLoading: this.state.loading || this.props.disableDownload,
        isDisabled: this.props.disableDownload,
        title: this.props.disableDownload ? this.props.disableDownloadMessage : 'Download as PDF',
        onClick: this.download
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].scrollWrapper,
        style: showPagination ? {
          height: this.props.height
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: showPagination ? {
          height: "".concat(this.state.reportHeight * this.getScale(), "px")
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: showPagination ? {
          transform: "scale(".concat(this.getScale(), ")"),
          transformOrigin: 'left top'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].report,
        ref: function ref(div) {
          _this2.report = div;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(div) {
          _this2.html = div;
        }
      }, this.props.children)))))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ReportWrapper, "propTypes", {
  /** The report wrapper width. If width < 870px then the report will be scaled down. Otherwise the report width will be 870px */
  width: _propTypes["default"].string,
  /** The height of the report wrapper. If wrapper height is less than report height then a scrollbar will be shown */
  height: _propTypes["default"].string,
  /** Disable download button or not? Could be useful for demo purposes */
  disableDownload: _propTypes["default"].bool,
  /** Message to show when disabling download button */
  disableDownloadMessage: _propTypes["default"].string,
  /** Show pagination style or not? */
  showPagination: _propTypes["default"].bool,
  /** Download file name without extension */
  downloadFilename: _propTypes["default"].string,
  /** Paper orientation: portrait or landscape */
  orientation: _propTypes["default"].string,
  size: _propTypes["default"].object,
  children: _propTypes["default"].node,
  onRef: _propTypes["default"].func
});
_defineProperty(ReportWrapper, "defaultProps", {
  width: '100%',
  height: 'auto',
  disableDownload: false,
  disableDownloadMessage: 'Download button is disabled',
  showPagination: true,
  onRef: function onRef() {},
  downloadFilename: 'file',
  orientation: 'portrait'
});
var _default = exports["default"] = (0, _reactSizeme["default"])({
  noPlaceholder: true,
  refreshRate: 200 // we don't need to refresh page so often (default 16)
})(ReportWrapper);